import React, { useEffect, useRef, useState } from "react";
import "./DoctorSection.css";
const DoctorSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <div
      ref={sectionRef}
      className={`doctor-section ${isVisible ? "animate" : ""}`}>
      {/* Left Fixed Card */}
      <div className="doctor-card fade-up">
        <img
          src="https://i.ibb.co/1GR1G0Xz/Save-Clip-App-469483120-17864062791277450-3833299510464549824-n-1.png"
          alt="Dr. Sudha Sagar- Best Gastroenterologist in Kompally Hyderabad - Krisara Gastro Clinic"
          className="doctor-image"/>
        <div className="doctor-info">
          <h3 className="doctor-name">Dr. Shruti Sagar MBBS, MD, DM, WEO-WISE</h3>
          <p className="doctor-title">
            Best Gastroenterologist in Kompally, Hyderabad 8 years of clinical
            and procedural experience 500+ advanced ERCPs & 300+ EUS procedures
          </p>
        </div>
      </div>
      {/* Right Scrollable Content */}
      <div className="doctor-details fade-right">
        <h4 className="about-heading">ABOUT US</h4>
        <h2 className="about-title">Meet Our Doctor</h2>
        <p className="about-description">
          Dr B Shruti Sagar is an experienced Consultant Gastroenterologist
           and Hepatologist with a special interest in Advanced Endoscopy 
           and Hepato-pancreaticobiliary disease management With over 8 years of
          specialized experience in digestive and liver disorders, he is
          dedicated to delivering patient-centered, evidence-based care.
        </p>
        <h4 className="sub-heading">Qualifications & Training:</h4>
        <ul className="about-list">
          <li>MBBS, Gandhi Medical College (2009–2015), Telangana</li>
          <li>MD (Internal Medicine) - M.S. Ramaiah Medical College & Hospital, Bangalore (2016–2019)</li>
          <li>DM (Gastroenterology) - M.S. Ramaiah Medical College & Hospital, Bangalore (2019–2022)</li>
          <li>W.I.S.E Accreditation for Endoscopic Ultrasound</li>
        </ul>
        <h4 className="sub-heading">Clinical Expertise:</h4>
        <ul className="about-list">
          <li>
            Diagnostic & therapeutic endoscopy (upper GI endoscopy, colonoscopy)
          </li>
          <li>
            Liver disease management, including non-invasive Fibroscan and viral
            hepatitis care
          </li>
          <li>
            Functional GI disorders (IBS, GERD) and gut-microbiome balancing
          </li>
          <li>Capsule endoscopy for small-bowel evaluation</li>
        </ul>
        <h4 className="sub-heading">Professional Affiliations:</h4>
        <ul className="about-list">
          <li>Indian Society of Gastroenterology(ISG)</li>
          <li>Society of Gastrointestinal Endoscopy of India  (API)</li>
          <li>World Endoscopy Organisation </li>
        </ul>
        <h4 className="sub-heading">Why Choose Dr. Sagar at Kompally:</h4>
        <ul className="about-list">
          <li>State-of-the-art endoscopy suite in Kompally, Hyderabad</li>
          <li>
            Compassionate care with same-day reporting and personalized follow-up
          </li>
          <li>
            Conveniently located near Kompally X-roads, with ample parking and
            easy access
          </li>
          <li>Insurance tie-ups with major providers in Telangana</li>
        </ul>
      </div>
    </div>
  );
};
export default DoctorSection;